import { COUNTRIES_DATA } from '../country-codes';

export const getDialCode = (countryCode: string) => {
  const data = COUNTRIES_DATA.find((x) => x.code === countryCode);
  const dialCode = data?.dial_code ?? '91';
  return dialCode.replace(/^\+/, '');
};

export const getCountryCode = (dialCode: string) => {
  const formattedDialCode = dialCode?.startsWith('+')
    ? dialCode
    : `+${dialCode || ''}`;
  const data = COUNTRIES_DATA.find((x) => x.dial_code === formattedDialCode);
  const countryCode = data?.code ?? 'IN';
  return countryCode;
};
